import { ORGANIZATION_SEARCH_QUERY, ORGANIZATION_SEARCH_RECEIVE, ORGANIZATION_SEARCH_SHOW_FULL_FORM, ORGANIZATION_SEARCH_SELECT_ITEM } from '../Actions/OrganizationSearch.action';

const DEFAULT_STATE = {
    query: '',
    result: [],
    showResult: false,
    selectedItem: -1
};

export const organizationSearch = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case ORGANIZATION_SEARCH_QUERY:
        case ORGANIZATION_SEARCH_RECEIVE:
        case ORGANIZATION_SEARCH_SHOW_FULL_FORM:
        case ORGANIZATION_SEARCH_SELECT_ITEM:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state;
    }
}
